module.exports = __webpack_public_path__ + "static/media/logo156.ea78660e.png";